import React, { useEffect, useState } from "react";
import { Row, Col, Button, Spin } from "antd";
import { ReactComponent as BackIcon } from "../../../assets/back-icon.svg";
import "../index.less";
import { fetchTemplate, templateCreationCleanupFunc } from "../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import UseSupAdminOrAdminWithUserManagerPermission from "../../../components/useSupAdminOrAdminWithUserManagerPermission";
import TemplateDetail from "./templateDetails";

const TemplateCreation = () => {
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const [isTemplateUpdate, setIsTemplateUpdate] = useState(false);
  let canEditEveryThing = UseSupAdminOrAdminWithUserManagerPermission();
  const [canUpdate, setCanUpdate] = useState(false);

  const { currentTemplateObj, fetchTemplateLoading } = useSelector(
    (state) => state.docTypesReducer
  );

  const { user } = useSelector((state) => state.authReducer);

  useEffect(() => {
    if (user?.permissions?.doc_types_manager?.add_edit) {
      setCanUpdate(true);
    }
  }, [user]);

  useEffect(() => {
    if (currentTemplateObj?.id) {
      setIsTemplateUpdate(true);
    }
  }, [currentTemplateObj]);

  useEffect(() => {
    if (params?.id) {
      setIsTemplateUpdate(true);
      dispatch(fetchTemplate(params?.id));
    }

    return () => {
      dispatch(templateCreationCleanupFunc());
    };
  }, [params.id]);

  return (
    <div className="page-top-div heading-parent-div">
      <Row justify="space-between">
        <Col>
          <span className="text-span">
            {isTemplateUpdate ? "Update " : "Add "} DOCUMENT TYPE TEMPLATE
          </span>
        </Col>
        <Col>
          <Button
            onClick={() => navigate("/settings/document-types-manager")}
            icon={<BackIcon width={24} height={14} />}
            className="back-btn"
            size="middle"
          >
            BACK
          </Button>
        </Col>
      </Row>
      <Spin spinning={fetchTemplateLoading}>
        <div className="user-manager-parent-div">
          <TemplateDetail
            isTemplateUpdate={isTemplateUpdate}
            canEditEveryThing={canEditEveryThing}
            canUpdate={canUpdate}
          />
          {/* {false && (
            <ProjectNotifications
              isProjectUpdate={isProjectUpdate}
              canEditEveryThing={canEditEveryThing}
            /> */}
          {/* )} */}
        </div>
      </Spin>
    </div>
  );
};

export default TemplateCreation;
